var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex justify-center"},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v("A página que procura não existe")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }